import { useEffect, useState } from "react";
import { Alert, Grid } from "@mui/material";
import ContractorPortalApi from "../../../../../infrastructure/api/contractorPortalApi";
import ContractorPortalPageShell from "../components/ContractorPortalPageShell";
import ContractorProjectCard from "../components/ContractorProjectCard";

const ContractorProjectsPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      const res = await ContractorPortalApi.getProjects();
      if (cancelled) return;
      if (!res?.isSuccess) {
        setError(res?.message || "خطا در بارگذاری پروژه‌ها.");
        setProjects([]);
      } else {
        setProjects(res.data?.projects || []);
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ContractorPortalPageShell
      title="پروژه‌های من"
      description="پروژه‌های اجرایی تخصیص‌یافته به پیمانکار"
      loading={loading}
      error={error}
    >
      {!projects.length ? (
        <Alert severity="info" data-testid="contractor-projects-empty">
          پروژه‌ای برای نمایش وجود ندارد.
        </Alert>
      ) : (
        <Grid container spacing={2} data-testid="contractor-projects-list">
          {projects.map((project) => (
            <Grid item xs={12} md={6} key={project.id}>
              <ContractorProjectCard project={project} />
            </Grid>
          ))}
        </Grid>
      )}
    </ContractorPortalPageShell>
  );
};

export default ContractorProjectsPage;
